/* assets/frenly-franchise.js (new, QA fix 2026-09-26)
   Client-side mirror of snippets/frenly-franchise-chip.liquid for JS-built
   rail cards (the homepage genre rail / named rail, built client-side
   from /collections/<handle>/products.json, and the generic site-wide
   card enhancer in frenly-flags.js). window.FrenlyFranchise.chipFor(product)
   returns a ready <span class="fb-lic-chip"> (or null). Keep this in step
   with the Liquid snippet -- same franchise table, same detection order
   (title, then a Theme:/License: tag, then tags generally, then
   product_type/vendor), same LEGO/Funko scope gate, same asset filenames. */
(function () {
  'use strict';

  var FRANCHISES = [
    { key: 'starwars', needles: [' star wars ', ' mandalorian ', ' skywalker ', ' darth vader ', ' yoda ', ' boba fett ', ' stormtrooper ', ' chewbacca '], asset: 'frenly-logo-starwars.svg', source: 'asset', mono: true, w: 42, h: 18 },
    { key: 'marvel', needles: [' marvel ', ' spider-man ', ' spiderman ', ' avengers ', ' iron man ', ' thor ', ' hulk ', ' captain america ', ' x-men ', ' deadpool ', ' black panther ', ' wolverine ', ' guardians of the galaxy '], asset: 'frenly-logo-marvel.svg', source: 'asset', mono: false, w: 44, h: 18 },
    { key: 'dc', needles: [' dc comics ', ' batman ', ' superman ', ' joker ', ' harley quinn ', ' wonder woman ', ' justice league ', ' aquaman '], asset: 'frenly-logo-dc.png', source: 'asset', mono: false, w: 22, h: 22 },
    { key: 'disney', needles: [' disney ', ' mickey mouse ', ' minnie mouse ', ' winnie the pooh ', ' lilo ', ' stitch ', ' frozen ', ' pixar '], asset: 'frenly-logo-disney.svg', source: 'asset', mono: true, w: 43, h: 18 },
    { key: 'harrypotter', needles: [' harry potter ', ' hogwarts ', ' hermione ', ' voldemort ', ' dumbledore '], asset: 'frenly-lic-harrypotter.svg', source: 'asset', mono: false, w: 46, h: 15 },
    { key: 'onepiece', needles: [' one piece ', ' luffy ', ' zoro '], asset: 'frenly-brand-onepiece.png', source: 'asset', mono: true, w: 46, h: 12 },
    { key: 'dragonball', needles: [' dragon ball ', ' dragonball ', ' goku ', ' vegeta '], asset: 'frenly-nav-dbs.png', source: 'asset', mono: false, w: 42, h: 18 },
    { key: 'naruto', needles: [' naruto ', ' sasuke ', ' akatsuki '], asset: 'frenly-lic-naruto.png', source: 'asset', mono: false, w: 22, h: 22 },
    { key: 'ninjago', needles: [' ninjago '], asset: 'menu-logo-ninjago.png', source: 'file', mono: true, w: 46, h: 10 },
    { key: 'jurassicworld', needles: [' jurassic world ', ' jurassic park '], asset: 'menu-logo-jurassicworld.svg', source: 'file', mono: true, w: 22, h: 22 },
    { key: 'minecraft', needles: [' minecraft '], asset: 'menu-logo-minecraft.svg', source: 'file', mono: true, w: 46, h: 8 }
  ];

  // Real, exact URLs for each logo asset -- printed by the small inline
  // script snippets/frenly-franchise-js-config.liquid renders next to
  // this file's own <script> tag, one {{ '...' | asset_url }} /
  // {{ '...' | file_img_url }} call per logo. Never guessed/reconstructed
  // here: asset_url and file_img_url paths are shop-specific and, for
  // Shopify Files, not a fixed pattern plain JS can rebuild.
  var ASSET_URLS = window.FrenlyFranchiseAssets || {};
  var FILE_URLS = window.FrenlyFranchiseFiles || {};

  function padWords(str) {
    return ' ' + String(str || '').toLowerCase().replace(/[\/\-(),]/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
  }

  function hasAny(hay, needles) {
    for (var i = 0; i < needles.length; i += 1) {
      if (hay.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  function tagsOf(product) {
    if (Array.isArray(product.tags)) return product.tags;
    return String(product.tags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }

  function chipFor(product) {
    var title = String(product.title || '');
    var type = String(product.product_type || product.type || '');
    var vendor = String(product.vendor || '');
    var tags = tagsOf(product);
    var tagsJoined = tags.join(' | ');
    var hayBase = (title + ' ' + type + ' ' + tagsJoined + ' ' + vendor).toLowerCase();

    var isLego = hayBase.indexOf('lego') !== -1 || hayBase.indexOf('minifig') !== -1;
    var isFunko = hayBase.indexOf('funko') !== -1 || hayBase.indexOf('pop!') !== -1 || hayBase.indexOf('pop vinyl') !== -1;
    if (!isLego && !isFunko) return null;

    var tagTheme = '';
    tags.forEach(function (t) {
      var dc = String(t).trim().toLowerCase();
      if (dc.indexOf('theme:') !== -1 || dc.indexOf('license:') !== -1) tagTheme += ' ' + dc;
    });

    var titleWords = padWords(title);
    var tagsDc = tagsJoined.toLowerCase();
    var pv = (type + ' ' + vendor).toLowerCase();

    var found = null;
    for (var i = 0; i < FRANCHISES.length && !found; i += 1) {
      var f = FRANCHISES[i];
      if (hasAny(titleWords, f.needles)) { found = f; break; }
      if (tagTheme && hasAny(tagTheme, f.needles)) { found = f; break; }
      if (hasAny(tagsDc, f.needles)) { found = f; break; }
      if (hasAny(pv, f.needles)) { found = f; break; }
    }
    if (!found) return null;

    var src = found.source === 'file' ? FILE_URLS[found.asset] : ASSET_URLS[found.asset];
    if (!src) return null; // config script didn't load (or a new key wasn't added there yet) -- never print a broken <img>


    var span = document.createElement('span');
    span.className = 'fb-lic-chip';
    span.setAttribute('data-fb-lic', found.key);
    span.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.loading = 'lazy';
    if (found.mono) img.className = 'fb-lic-mono';
    img.style.width = found.w + 'px';
    img.style.height = found.h + 'px';
    span.appendChild(img);
    return span;
  }

  // v2.66 (17 Oct 2026): a card can only ever hold ONE franchise chip. Re-renders, infinite
  // scroll and the site-wide enhancer used to call chipFor again on a card that already had
  // one (two Dragon Ball chips). dedupe keeps the first chip of each card and removes the
  // rest; place is the idempotent way to add a chip (it returns the chip already there).
  function dedupe(card) {
    if (!card || !card.querySelectorAll) return null;
    var chips = card.querySelectorAll('.fb-lic-chip');
    for (var i = 1; i < chips.length; i += 1) {
      if (chips[i].parentNode) chips[i].parentNode.removeChild(chips[i]);
    }
    return chips[0] || null;
  }

  function place(card, product, afterEl) {
    if (!card) return null;
    var have = dedupe(card);
    var row = card.querySelector('.fb-flags');
    if (have) {
      if (row && have.parentElement !== row) row.appendChild(have);
      return have;
    }
    var chip = chipFor(product);
    if (!chip) return null;
    if (row) {
      row.appendChild(chip);
    } else if (afterEl && afterEl.insertAdjacentElement) {
      var lone = document.createElement('div');
      lone.className = 'fb-flags fb-flags--rail';
      lone.appendChild(chip);
      afterEl.insertAdjacentElement('afterend', lone);
    } else {
      return null;
    }
    return chip;
  }

  window.FrenlyFranchise = { chipFor: chipFor, place: place, dedupe: dedupe };
})();
